import { h } from './index.js';

function getAsChild([asElement, asProps], children, defaultProps) {
    const _defaultProps = defaultProps ? defaultProps[asElement] : undefined;
    const passProps = { ..._defaultProps, ...asProps };
    return h(asElement, passProps, children);
}

export { getAsChild as g };
